import { getFileExtension } from "../../../utils/data/getFileExtension";

export const isEntityDisabled = (
  entity: any,
  forbiddenRootFolderName: string,
  forbiddenExtensions: string[]
) => {
  if (!entity) {
    return false;
  }
  const { fullPath } = entity;
  if (!fullPath) {
    return false;
  }

  const rootFolderPath = fullPath.split("/")[0];
  if (forbiddenRootFolderName.toLowerCase() !== rootFolderPath.toLowerCase()) {
    return false;
  }
  const fileExtension = getFileExtension(entity.fileName);
  return forbiddenExtensions.includes(fileExtension);
};
